module.exports = __webpack_public_path__ + "img/copywrite.a271bcf0.svg";